import React from 'react';

const PercentageGraph = ({ percentage, displayBall, hideLabel }) => {
  let barColor;

  if (!percentage) {
    barColor = '#f1f1f2';
  } else if (percentage <= 24.99) {
    barColor = '#fedb00';
  } else if (percentage <= 49.99) {
    barColor = '#ffec9c';
  } else if (percentage <= 74.99) {
    barColor = '#bff5aa';
  } else if (percentage <= 100) {
    barColor = '#6cc24a';
  }

  if (displayBall) {
    const formatPercentage = (value) => {
      if (value < 10) {
        return ` ${value}`;
      }
      return value;
    };

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
        }}
      >
        {percentage || percentage === 0 ? (
          <div
            role="img"
            aria-label={`Percentage value: ${percentage}%`}
            style={{
              width: 16,
              height: 16,
              borderRadius: '50%',
              backgroundColor: barColor,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 10,
            }}
          />
        ) : (
          <div style={{ padding: '0.5px' }}>NA</div>
        )}
        {!hideLabel && (percentage || percentage === 0) && (
          <span>{formatPercentage(percentage)}%</span>
        )}
      </div>
    );
  }

  return (
    <div
      style={{ width: '100%', backgroundColor: '#f1f1f2' }}
      role="progressbar"
      aria-valuenow={percentage}
      aria-valuemin={0}
      aria-valuemax={100}
      className="percentage-graph"
    >
      <div
        style={{
          width: `${percentage}%`,
          height: 20,
          backgroundColor: barColor,
          padding: '14px 12px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {percentage || percentage === 0 ? (
          <span style={{ fontWeight: 'bold' }}>{percentage}%</span>
        ) : (
          <span style={{ fontWeight: 'bold' }}>NA</span>
        )}
      </div>
    </div>
  );
};

export default PercentageGraph;
